import { useGlobalStore } from '@/features/Global/store';
import spartenConfigs from '@/features/Sparten';
import type { SpartenConfigGeneral } from '@/features/Sparten/types';
import { ROLE, type Role } from '@/features/Clients';

export const getCurrentSpartenConfig = (): SpartenConfigGeneral => {
  const sparte = useGlobalStore().getSparte;
  return spartenConfigs[sparte].general;
};

export const getRelevantVPRoles = (): Role[] => {
  const { relevantVPRoles } = getCurrentSpartenConfig();

  return relevantVPRoles ?? [ROLE.VERSICHERTE_PERSON];
};
